export default "__VITE_PUBLIC_ASSET__34feda4f__"